import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=ed83e454"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=ed83e454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports